var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParentCompaniesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66444 2.66504H9.33389C9.70223 2.66504 10.0008 2.96364 10.0008 3.33198V13.3362H2.66444C2.2961 13.3362 1.9975 13.0375 1.9975 12.6692V3.33198C1.9975 2.96364 2.2961 2.66504 2.66444 2.66504Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0008 5.33301H13.3356C13.7039 5.33301 14.0025 5.63161 14.0025 5.99995V12.6694C14.0025 13.0377 13.7039 13.3363 13.3356 13.3363H10.0008V5.33301Z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66528 5.24913C4.61924 5.24913 4.58191 5.28645 4.58191 5.3325C4.58191 5.37854 4.61924 5.41586 4.66528 5.41586C4.71132 5.41586 4.74865 5.37854 4.74865 5.3325C4.74865 5.28645 4.71132 5.24913 4.66528 5.24913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33306 5.24913C7.28701 5.24913 7.24969 5.28645 7.24969 5.3325C7.24969 5.37854 7.28701 5.41586 7.33306 5.41586C7.3791 5.41586 7.41642 5.37854 7.41642 5.3325C7.41642 5.28645 7.3791 5.24913 7.33306 5.24913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66528 7.9171C4.61924 7.9171 4.58191 7.95442 4.58191 8.00046C4.58191 8.04651 4.61924 8.08383 4.66528 8.08383C4.71132 8.08383 4.74865 8.04651 4.74865 8.00046C4.74865 7.95442 4.71132 7.9171 4.66528 7.9171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33306 7.9171C7.28701 7.9171 7.24969 7.95442 7.24969 8.00046C7.24969 8.04651 7.28701 8.08383 7.33306 8.08383C7.3791 8.08383 7.41642 8.04651 7.41642 8.00046C7.41642 7.95442 7.3791 7.9171 7.33306 7.9171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66528 10.5851C4.61924 10.5851 4.58191 10.6224 4.58191 10.6684C4.58191 10.7145 4.61924 10.7518 4.66528 10.7518C4.71132 10.7518 4.74865 10.7145 4.74865 10.6684C4.74865 10.6224 4.71132 10.5851 4.66528 10.5851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33306 10.5851C7.28701 10.5851 7.24969 10.6224 7.24969 10.6684C7.24969 10.7145 7.28701 10.7518 7.33306 10.7518C7.3791 10.7518 7.41642 10.7145 7.41642 10.6684C7.41642 10.6224 7.3791 10.5851 7.33306 10.5851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 7.9171C11.9556 7.9171 11.9183 7.95442 11.9183 8.00046C11.9183 8.04651 11.9556 8.08383 12.0017 8.08383C12.0477 8.08383 12.085 8.04651 12.085 8.00046C12.085 7.95442 12.0477 7.9171 12.0017 7.9171"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 10.5851C11.9556 10.5851 11.9183 10.6224 11.9183 10.6684C11.9183 10.7145 11.9556 10.7518 12.0017 10.7518C12.0477 10.7518 12.085 10.7145 12.085 10.6684C12.085 10.6224 12.0477 10.5851 12.0017 10.5851"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentCompaniesIcon);
export default __webpack_public_path__ + "static/media/ParentCompaniesIcon.ce69dd4b4d50ef2aaa9a5f8be9cfb3a7.svg";
export { ForwardRef as ReactComponent };